let result;

export const getApi = () => {
  if (result) return Promise.resolve(result);
  return import('./darkmode').then((module) => {
    result = module;
    return module;
  });
};